module.exports = __webpack_public_path__ + "static/media/appledownload.fbe19a22.png";